import isEmptyArray from 'utils/predicates/array/isEmptyArray.util';

const isNotEmptyArray = (value) => !isEmptyArray(value);

// noinspection JSUnusedGlobalSymbols
export default isNotEmptyArray;
